import * as React from "react";
import classnames from "classnames";
import { Spinner } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import TimeSlotItemContainer from "../../../TimeSlotsItem/v3/components/TimeSlots/TimeSlotsItem/TimeSlotsItemContainer.js";
import { isEqualTimeSlot } from "./utils.js";
/* empty css               */
const TimeSlots = ({
  className,
  loading,
  slots,
  selected,
  timeFormatter,
  onSelectTime,
  ...rest
}) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("timeslots", className) }, loading ? /* @__PURE__ */ React.createElement("div", { className: "timeslots__loader" }, /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") })) : slots.map((slot) => /* @__PURE__ */ React.createElement(
    TimeSlotItemContainer,
    {
      key: slot.from.toUTCString(),
      selected: isEqualTimeSlot(slot, selected),
      label: timeFormatter(slot.from),
      slot,
      onSelect: onSelectTime
    }
  )));
};
export {
  TimeSlots as default
};
//# sourceMappingURL=TimeSlots.js.map
